// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1PQNp","additionalInfo":"AgreementModal_additionalInfo__2WvHs"};